import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { OperatorAuthService } from './operator-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(OperatorAuthService);
  const apiBaseUrl = environment.cloudApiBaseUrl;

  if (!req.url.startsWith(apiBaseUrl)) {
    return next(req);
  }

  const token = auth.getAuthToken();
  const isRefreshRequest = isOperatorRefreshRequest(req.url, apiBaseUrl);
  const isLogoutRequest = isOperatorLogoutRequest(req.url, apiBaseUrl);
  const requestWithAuth = req.clone({
    withCredentials: true,
    setHeaders: {
      ...(token && !isRefreshRequest && !isLogoutRequest ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (isRefreshRequest || isLogoutRequest) {
    return next(requestWithAuth);
  }

  return next(requestWithAuth).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }

      return auth.refreshSession().pipe(
        switchMap((freshToken) => {
          if (!freshToken) {
            return throwError(() => error);
          }

          return next(
            req.clone({
              withCredentials: true,
              setHeaders: {
                Authorization: `Bearer ${freshToken}`,
              },
            }),
          );
        }),
        catchError(() => throwError(() => error)),
      );
    }),
  );
};

export function isOperatorRefreshRequest(url: string, apiBaseUrl: string): boolean {
  return url === `${apiBaseUrl}/operator/auth/token`;
}

export function isOperatorLogoutRequest(url: string, apiBaseUrl: string): boolean {
  return url === `${apiBaseUrl}/operator/auth/logout`;
}
